import {
	Text,
	Textarea as ChakraTextarea,
	TextareaProps as ChakraTextareaProps,
	Box,
} from "@chakra-ui/react";
import {
	ChangeEvent,
	FocusEvent,
	forwardRef,
	useEffect,
	useState,
} from "react";
import { useFormContext } from "react-hook-form";

const Textarea = forwardRef<
	HTMLTextAreaElement,
	ChakraTextareaProps & { name: string }
>(({ children, placeholder, onChange, onBlur, onFocus, ...props }, ref) => {
	const [value, setValue] = useState("");
	const [active, setActive] = useState(false);
	const { watch } = useFormContext();
	const watcher = watch(props.name);
	useEffect(() => {
		if (watcher != null && watcher !== value) {
			setValue(watcher);
			setActive(watcher !== "");
		}
	}, [watcher, value, setValue, setActive]);

	const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
		setValue(event.target.value);
		setActive(event.target.value !== "");
		if (onChange) {
			onChange(event);
		}
	};

	const handleBlur = (event: FocusEvent<HTMLTextAreaElement, Element>) => {
		if (value === "") {
			setActive(false);
		} else {
			setActive(true);
		}
		if (onBlur) {
			onBlur(event);
		}
	};

	const handleFocus = (event: FocusEvent<HTMLTextAreaElement, Element>) => {
		setActive(true);
		if (onFocus) {
			onFocus(event);
		}
	};

	return (
		<Box mt={props.mt}>
			<ChakraTextarea
				ref={ref}
				id={props.id}
				name={props.name}
				onFocus={handleFocus}
				onBlur={handleBlur}
				value={value}
				onChange={handleChange}
			>
				{children}
			</ChakraTextarea>
			<Text
				position="absolute"
				top="0%"
				left="5px"
				transform={
					active
						? "translate(10px,-10px) scale(0.8)"
						: "translate(10px,8px) scale(1)"
				}
				color="gray.500"
				px={1}
				transformOrigin="top left"
				transition="all .2s ease-out"
				pointerEvents="none"
				bg="white"
				w="fit-content"
				h="fit-content"
				zIndex={5}
			>
				{placeholder}
			</Text>
		</Box>
	);
});

export default Textarea;
